module.exports = __webpack_public_path__ + "img/idoors_logo_white.d0d9c27d.png";